import styled from 'styled-components';
import DefaultModal from 'components/Modals/Modal';
import { Subtitle } from 'components/Typography';
import { FiInfo } from 'react-icons/fi';

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const Modal = styled(DefaultModal)``;

// TODO: TFR-44 move to container group or do not export
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0rem;
  width: 22.75rem;
  height: 9.625rem;
`;

// TODO: TFR-49 move in different component
export const InfoIcon = styled(FiInfo)`
  width: 2rem;
  height: 2rem;
  margin-bottom: 1.6875rem;
  color: ${({ theme }) => theme.colors.blueMedium};
`;

// TODO: TFR-45:Text make unique name or do not export
export const Text = styled(Subtitle)`
  color: ${({ theme }) => theme.colors.navyGreen};
  margin-top: 1rem;
  text-align: center;
  font-weight: 700;
`;
